import { OptionModel } from "./option.model";

export class AttributeModel {
    uid?: string
    key: string
    value?: string
    type: string
    options?: OptionModel[] = []
    attributes?: AttributeModel[] = []
    postEvents?: AttributeModel[] = []
    hasError?: boolean
    isActive?: boolean

    constructor() {
        this.options = []
        this.attributes = []
        this.postEvents = []
    }
}
